export default {
  name: 'FollowInvitationMessage',
  props: {
    data: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      isClicked: false
    };
  },
  methods: {
    followHandler: function followHandler() {
      var _this = this;
      this.$emit('subscribe', this.data.uid, false);
      this.$nextTick(function () {
        _this.isClicked = true;
        _this.$emit('scrollToEnd');
      });
    }
  },
  mounted: function mounted() {
    this.$emit('scrollToEnd');
  }
};